module.exports = __webpack_public_path__ + "static/media/1010.61005303.png";